<template>


  <b-row class="mt-2 d-flex align-items-center">

    <label class="col-2"> <strong> OCURRENCIA: </strong> </label>

    <v-select 
      v-if="motivoConsultaOpts" 
      class="col-5 text-right" 
      placeholder="Seleccione una opcion"
      :options="motivoConsultaOpts" 
      :reduce="option => option.value" 
      label="text" 
      v-model="ocurrencia"
      :clearable="false" 
    />

    <div class="d-flex align-items-center justify-content-end mx-2 mb-1">
      <h6 class="mx-1 mb-0">Es interconsulta:</h6>
      <b-form-checkbox v-model="esInterconsulta" switch />
      <span style="width: 25px">{{ esInterconsulta ? 'Si' : 'No' }}</span>
    </div>

  </b-row>

</template>

<script>
import { mapState } from "vuex";
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import vSelect from "vue-select";


export default {

  name: "TipoVez",

  components: {
    vSelect
  },

  data() {
    return {
      visibleBody: false,
      motivoConsultaOpts: [],
      esInterconsulta: false,
      ocurrencia: null,
      textoMotivo: ''
    }
  },

  async created() {
    await this.getMotivoConsultaOpts();
    this.loadData();
  },


  methods: {

    loadData(){

      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;

      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if(this.idCita) this.loadDataLS();

      if(this.tokenAtencion) this.ocurrencia = this.stOcurrencia;      
    },

    loadDataLS() {
      const anamnesis = JSON.parse(localStorage.getItem("crearAnamnesis"));
      const ocurrencia = anamnesis?.ocurrencia;

      if(!ocurrencia) return;
      this.ocurrencia = ocurrencia;
    },


    async getMotivoConsultaOpts() {

      const query = `
        query MyQuery {
          allTipoconsulta {
            descripcion
            id
          }
        }
      `;

      try {
        const result = await axios.post(rutas.axios + 'api', { query });

        const optsTipoConsulta = result.data.data.allTipoconsulta.slice(0, 2);

        this.motivoConsultaOpts = optsTipoConsulta.map(
          motivo => ({
            value: motivo.id,
            text: motivo.descripcion
          })
        );

      } catch (error) {
        console.error(error);
      }
      
    }
  },


  computed: {
    ...mapState({
      stOcurrencia: state => state.atencionCita.anamnesis?.ocurrencia,
    }),
  },


  watch: {

    stOcurrencia: {
      immediate: true,
      handler(newValue) {
        if (this.tokenAtencion && newValue) {
          this.ocurrencia = newValue;
        }
      }
    },

    ocurrencia: {
      deep: true,
      handler(newValue) {
        if (this.stOcurrencia !== newValue) {
          this.$store.commit("setOcurrencia", newValue);
        }
      }
    },

    esInterconsulta: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setEsInterconsulta", newValue);
      }
    }
  },

  

}
</script>